// wwwroot/js/src/ark-theme.js

window.ArkUI = window.ArkUI || {};
window.ArkUI.Theme = window.ArkUI.Theme || {};

// 获取当前系统是否为暗色
window.ArkUI.Theme.isSystemDark = function() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
};

// 设置 HTML 根节点主题属性（任意主题名）
window.ArkUI.Theme.setDomTheme = function(themeName) {
    document.documentElement.setAttribute('data-theme', themeName);
};

// 兼容旧调用：仅 light/dark 二态
window.ArkUI.Theme.setDomDark = function(isDark) {
    window.ArkUI.Theme.setDomTheme(isDark ? 'dark' : 'light');
};

// 监听系统主题变化
window.ArkUI.Theme.watchSystemChange = function(dotNetRef) {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    // 防止重复绑定，可以加个标记（可选）
    // if (mediaQuery.hasArkListener) return;

    mediaQuery.addEventListener('change', (e) => {
        dotNetRef.invokeMethodAsync('OnSystemThemeChanged', e.matches);
    });
};